import { EDUCATOR_ROLES, SHOW_ADMIN_ROLES, UserRole } from '../../models/common/user-role.type';

/** The distinct login/portal namespaces in the app. */
export type PortalType = 'family' | 'educator' | 'showAdmin';

/** Login route for a portal namespace, e.g. `/educator/login`. */
export function loginRouteForPortal(portal: PortalType): string {
  switch (portal) {
    case 'educator':
      return '/educator/login';
    case 'showAdmin':
      return '/show-admin/login';
    default:
      return '/family/login';
  }
}

/** Which portal a signed-in user belongs to, derived from their JWT role. */
export function portalForRole(role: string | undefined): PortalType {
  if (role && SHOW_ADMIN_ROLES.includes(role as UserRole)) {
    return 'showAdmin';
  }
  if (role && EDUCATOR_ROLES.includes(role as UserRole)) {
    return 'educator';
  }
  return 'family';
}

/**
 * Derive the educator's UserRole from the login response (interim, until the
 * JWT carries a role claim). A district association / job title => District
 * Agent; a county/CEA title => County Agent; otherwise Ag Teacher.
 */
export function educatorRoleFromJobTitle(jobTitle: string | undefined, hasDistrict: boolean): UserRole {
  if (hasDistrict) {
    return UserRole.DISTRICT_AGENT;
  }
  const title = (jobTitle ?? '').toLowerCase();
  if (title.includes('district')) {
    return UserRole.DISTRICT_AGENT;
  }
  if (title.includes('county') || title.includes('cea')) {
    return UserRole.COUNTY_AGENT;
  }
  return UserRole.AG_TEACHER;
}

/** Landing route for a portal namespace, e.g. `/educator`. */
export function homeRouteForPortal(portal: PortalType): string {
  switch (portal) {
    case 'educator':
      return '/educator';
    case 'showAdmin':
      return '/show-admin';
    default:
      return '/family/dashboard';
  }
}

/** Landing route a signed-in user should be sent to, by JWT role. */
export function portalHomeForRole(role: string | undefined): string {
  return homeRouteForPortal(portalForRole(role));
}
